import { Pipe, PipeTransform } from '@angular/core';

import { Characteristic } from '../../order/models/characteristic';
import { UNDERSCORE } from '../utils/constant';
import { formatNumber, NumberFormat } from '../utils/number.format';
import { TranslationService } from '../services/translation.service';

@Pipe({
	name: 'copoCharac',
})
export class CharacPipe implements PipeTransform {
	constructor(private readonly translationService: TranslationService) {}

	transform(characteristic?: Partial<Characteristic>, replacement: string = UNDERSCORE) {
		if (characteristic) {
			if (characteristic.valueDescription) {
				return characteristic.valueDescription;
			}
			if (characteristic.valueCode) {
				return characteristic.code ? this.updateX(characteristic) : characteristic.valueCode;
			}
			let formatType: NumberFormat;
			switch (characteristic.code) {
			case 'DI03':
				formatType = 'thickness';
				break;
			case 'DI06':
				formatType = 'width';
				break;
			case 'PA01':
				return this.updateX(characteristic);
			default:
				formatType = 'generic';
				break;
			}
			return formatNumber(characteristic.valueNum, formatType, characteristic.valueUnit);
		}
		return replacement;
	}

	updateX(characteristic?: Partial<Characteristic>) {
		return characteristic && characteristic.valueCode === 'X'
			? this.translationService.getTR('global.yes') : this.translationService.getTR('global.no');
	}
}
